
import UnlockableContainer from '@/components/collection/drop/DropContainer.vue'
export default {
  components: {
    UnlockableContainer,
  },
  layout: 'unlockable-mint-layout',
}
